document.addEventListener('DOMContentLoaded', function() {
  var opinionContainer = document.querySelector('.opinionContainer');
  var opinions = opinionContainer.querySelectorAll('.opinionRating');
  var ratingCounts = { '5': 0, '4': 0, '3': 0, '2': 0, '1': 0 };
  var totalOpinions = opinions.length;

  // Count the occurrences of each rating
  opinions.forEach(function(opinion) {
    var rating = opinion.textContent.trim().split('/')[0];
    if (ratingCounts[rating] !== undefined) {
      ratingCounts[rating]++;
    }
  });

  // Calculate the percentage for each rating
  var ratingPercentages = {};
  for (var rating in ratingCounts) {
    ratingPercentages[rating] = (ratingCounts[rating] / totalOpinions) * 100;
  }

  // Update the bar widths and side elements with the calculated percentages
  for (var rating in ratingPercentages) {
    var bar = document.querySelector('.bar-' + rating);
    var side = document.querySelector('.bar-' + rating + '-side');
    if (bar) {
      bar.style.width = Math.round(ratingPercentages[rating]) + '%';
    }
    if (side) {
      side.textContent = Math.round(ratingPercentages[rating]) + '%';
    }
  }

  // Calculate the average rating
  var totalRating = 0;
  var totalCount = 0;
  for (var rating in ratingCounts) {
    totalRating += ratingCounts[rating] * parseInt(rating);
    totalCount += ratingCounts[rating];
  }
  var averageRating = (totalRating / totalCount).toFixed(2);

  // Update the average rating display
  var ratingDisplay = document.querySelector('.ratingvalue');
  if (ratingDisplay) {
    setTimeout(function() {
      ratingDisplay.textContent = `${averageRating} / 5`;
    }, 500);
    ratingDisplay.textContent = `${averageRating} / 5`;
  }
});